/**
 * Analytics providers `useTrackingManager` can route events to. Add new
 * entries here (and a matching branch in `getTrackingService`) instead of
 * growing a boolean flag when a new provider is introduced.
 */
export enum TrackingProvider {
  mixpanel = 'mixpanel',
  segment = 'segment',
  mock = 'mock',
}
